<section *ngIf="!isOpened">
  <div class="col-12 col-sm-12">
    <div class="row">
      <form class="needs-validation container-style" [formGroup]="formImport">
        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="row">
              <div class="col-12 fw-bold mb-2">
                <label>
                  Para realizar el proceso de importación de notas, descargue la guía y siga los pasos:
                </label>
              </div>
              <div class="row d-flex justify-content-between">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                      <app-custom-autocomplete formControlName="companyId" [labelText]="'Compañía'"
                        [list]="listCompanies" [required]="true" [recovery]="true"
                        (onChangeSelect)="getCompany($event)">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-lg-2 col-md-6 col-sm-6 col-12">
                      <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                        [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event)">
                      </app-custom-select>
                    </div>
                    <div class="col-lg-2 col-md-6 col-sm-5 col-12">
                      <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                        [required]="true" [recovery]="true" (onChangeSelect)="getEnterprise($event)">
                      </app-custom-select>
                    </div>

                    <!-- Botón de archivo -->
                    <div class="col d-flex align-items-end gap-1 my-2 my-md-0">
                      <app-custom-button [title]="'Información.'" [severity]="'secondary'" [icon]="'pi pi-info-circle'"
                        (onClick)="openToggle($event)"></app-custom-button>
                      <app-custom-button [title]="'Seleccionar Archivo'" [label]="'Seleccionar Archivo'"
                        [severity]="'success'" [width]="'10rem'" [icon]="'pi pi-upload'" (onClick)="attach()"
                        [disabled]="!permissionUpdatable">
                      </app-custom-button>
                      <input id="fileImport" type="file" (change)="getNameFile($event)" hidden>
                      <p class="m-0">{{nameFile}}</p>
                    </div>
                    <p-popover #information>
                      <div>
                        <div class="">
                          <span>
                            <b>Información</b>
                            <br>
                            Este proceso revisa todas las notas en el archivo de Excel.
                            <br>
                            Si una nota no existe, se crea automáticamente.
                            <br>
                            Si la nota ya existe, se actualizan sus valores.
                            <br>
                          </span>
                        </div>
                      </div>
                    </p-popover>
                    <!-- Botones de acción -->
                    <div class="d-flex d-flex justify-content-between gap-1 mt-2">
                      <app-custom-button [label]="'Descargar Guía Import.'" [severity]="'success'" [width]="'10rem'"
                        [disabled]="!permissionUpdatable" (onClick)="downloadGuideImport()">
                      </app-custom-button>
                      <app-custom-button [label]="'Importar'" [severity]="'primary'" [disabled]="!permissionUpdatable"
                        [width]="'5rem'" [variant]="undefined" (onClick)="importNotes()">
                      </app-custom-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div id="list" *ngIf="visibleTxt">
                <h6>Lista de Errores y Alertas</h6>
                <p>Total errores: {{notesAlerts.length}}</p>
                <div id="container-alerts" *ngFor="let notesAlert of notesAlerts">
                  <p [ngClass]="errorNotes == 1 ? 'message-error' : 'message-alert'">
                    {{notesAlert.message}}
                  </p>
                </div>
              </div>
              <div class="row" *ngIf="visibleTxt">
                <div class="d-flex justify-content-end">
                  <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'"
                    [width]="'5.5rem'" (onClick)="downloadErrorsTxt()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>